import pkg from "../../package.json";

export class Constantes {
	static readonly PUESTO_OPE = "No existen OPEs";

	static readonly UBICACION_PERDIDOS = "Z00Z00";

	static readonly existenSubfamilias: boolean = false;

	static readonly articulosDesubicados: boolean = true;

	static readonly elegirComponentesOF: boolean = true;

	static readonly existenCiclos: boolean = false;

	static readonly existenFases: boolean = false;

	static readonly existenLotes: boolean = true;
}


export const REGEX_CONTENEDOR = /^@(\d+)$/;
export const REGEX_UBICACION = /^([A-Z]{1}\d{2}[A-Z]{1}\d{2})$/;
export const REGEX_PUESTO = /^(P-\d{2})$/;


export function getApiURL(url: string, queryParams = ""): string {
	const localUrl = localStorage.getItem(pkg.name + ".BASE_API_URL");
	if (localUrl) return `${localUrl}${url}${queryParams}`;

	if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
		alert("Usando API local para desarrollo");
		return `http://almacen.rial.intranet${url}${queryParams}`;
	}

	let { hostname } = location;
	if (hostname.startsWith("www.")) hostname = hostname.substring(4);
	if (hostname.startsWith("web.")) hostname = hostname.substring(4);

	if (hostname == "almacen.piher.com") return `https://${hostname}/api/v1${url}${queryParams}`;

	return `${location.protocol}//api.${hostname}${url}${queryParams}`;
}